module.exports = __webpack_public_path__ + "static/media/partitions_allImpact_60y_y.7cc1d964.csv";